import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ExtractTasks } from '~src/extract/resources/ExtractTasks';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ExtractTaskContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const ExtractTaskDefinition: ExplorableItemDefinition = {
  itemType: 'extractTask',
  pluralName: Messages.extractTasks,
  singularName: Messages.extractTask,
  emptyStateMessage: Messages.extractTasksEmptyMessage,
  contentFilterKeys: [],
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['extractTask']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return ExtractTasks.all().withExtraParams(ExtractTaskContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list']
};
